<div class="wrapper">
  <app-meeting-details-card
    [meeting]="meeting"
    [metadata]="meeting.agendaMetadata"
    [canEdit]="canEdit"
    [title]="'MEETING_SETUP.MEETING_DETAILS.TITLE' | translate"
    (detailsSaved)="onDetailsSaved($event)"
  ></app-meeting-details-card>

  <div class="item meeting-profile-selection">
    <h2 translate="COMMON.MEETING_PROFILE"></h2>
    <p class="meeting-profile-description" translate="MEETINGS.MEETING_INFO.MEETING_PROFILE_DESCRIPTION"></p>
    @if (meetingProfiles$ | async; as result) {
      @if (result.isSuccess) {
        <app-select
          name="meeting-profile-id"
          [ngModel]="meeting.meetingProfileId"
          (ngModelChange)="updateMeetingProfile($event)"
          [disabled]="!canEdit"
          labelKey="COMMON.MEETING_PROFILE"
          nullValueLabelKey="MEETINGS.ADMIN.TEAM_DEFAULT"
          [options]="getMeetingProfileOptions(result.data)"
        ></app-select>
      }
    }
  </div>
  <div class="item document-upload-container">
    <h2 translate="MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.TITLE"></h2>
    <div class="uploaded-documents-container">
      @if (meeting.userUploadedResources.length > 0) {
        <h3>{{ 'MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.UPLOADED_DOCUMENTS' | translate }}</h3>
      }
      @for (resource of meeting.userUploadedResources; track $index) {
        <div class="uploaded-document">
          <mat-icon>attach_file</mat-icon>
          <div class="details">
            <div class="file-info">
              <strong>{{ 'MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.' + resource.resourceType | translate }}:</strong>
              <span class="mask-file-names">{{ resource.fileName }}</span>
            </div>
            <div class="upload-date">{{ 'MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.UPLOADED' | translate }}: {{ resource.createdAt | date: 'd MMM y' }}</div>
            @if (resource.resourceType === 'AGENDA' && isCheckingAgendaValidity) {
              <div class="agenda-status checking">
                <span>{{ 'MEETING_SETUP.TEMPLATE_REVIEW.CHECKING_AGENDA_DOCUMENT' | translate }}</span>
                <app-progress-loader indeterminate thin></app-progress-loader>
              </div>
            }
          </div>
          @if (resource.downloadUrl !== null) {
            <mat-icon class="clickable" (click)="downloadResource(resource)" [matTooltip]="'COMMON.DOWNLOAD' | translate">download</mat-icon>
          }
          @if (isAuthorizedToManageDocuments) {
            <mat-icon class="clickable" color="warn" (click)="removeUpload(resource)" [matTooltip]="'COMMON.REMOVE' | translate">delete</mat-icon>
          }
        </div>
      } @empty {
        @if (!isAgendaExtractionFailed) {
          <p translate="MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.NO_DOCUMENTS"></p>
        }
      }
      @if (isAgendaExtractionFailed && !hasAgendaUploaded) {
        <div class="uploaded-document rejection-notice">
          <div class="agenda-status failed standalone">
            <mat-icon>error_outline</mat-icon>
            <span>{{ agendaFailureMessageKey | translate }}</span>
          </div>
        </div>
      }
    </div>
    @if (isAuthorizedToManageDocuments && missingDocuments.length > 0) {
      <div class="new-upload-container">
        <h3>{{ 'MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.UPLOAD_NEW_DOCUMENT' | translate }}</h3>
        @if (meeting.agendaType === 'MULTIPLE') {
          <div>
            <mat-icon class="warning-icon">warning</mat-icon>
            <span class="warning-text">{{ 'MEETINGS.MEETING_INFO.DOCUMENT_UPLOAD.MULTI_AGENDA_WARNING' | translate }}</span>
          </div>
        }
        <app-meeting-document-upload [meetingId]="meeting.id" [acceptedDocuments]="missingDocuments"></app-meeting-document-upload>
      </div>
    }
  </div>
  <div class="item minutes-styling">
    @if (showReprocessOutputsButton && canEdit) {
      <div class="warning-container">
        <mat-icon class="warning-icon">warning</mat-icon>
        <div class="warning-content">
          <div class="warning-title">{{ 'MEETINGS.REPROCESS_OUTPUTS.SETTINGS_CHANGED' | translate }}</div>
          <div class="warning-message">
            {{ 'MEETINGS.REPROCESS_OUTPUTS.WARNING' | translate }}
            <div class="warning-action">
              <button mat-raised-button (click)="reprocessOutputs()">{{ 'MEETINGS.REPROCESS_OUTPUTS.TITLE' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
    <h2 translate="MINUTES_STYLING.TITLE"></h2>
    <app-minutes-styling
      [namingDisabled]="meeting.attendeeNames.length === 0"
      [honorificDisabled]="anyAttendeeMissingHonorific"
      [disabled]="!canEdit"
      [data]="meeting"
      [governingBodyType]="meeting.agendaMetadata.governingBodyType"
      [enabledMinutesLanguages]="(enabledMinutesLanguages$ | async) ?? ['BRITISH', 'AMERICAN']"
      [transcriptLanguage]="meeting.transcriptLanguage"
      (update)="updateMinutesStyling($event)"
    ></app-minutes-styling>
  </div>
</div>
